import { gql } from '@apollo/client';

export const GET_PRODUCT_IDS_WITH_TITLES = gql`
  query SkWeb_ProductIdsWithTitles {
    productIdsWithTitles
  }
`;
